<div class="tw-mx-4 tw-bg-teal-700 tw-p-4 tw-pt-8 tw-rounded-3 tw-text-white tw-relative" [ngClass]="cssClasses" (click)="handleClick()">
  <div class="tw-text-500 tw-mb-[15px] tw-leading-[20px]">
    <ng-content></ng-content>
  </div>
  <div class="tw-h-[1px] tw-bg-teal-200 tw-opacity-20 tw-mb-5"></div>
  <div class="tw-flex tw-items-center tw-justify-between tw-gap-2">
    <div class="tw-flex tw-items-center">
      <img [src]="doctorDetails.image" alt="doctor"
           class="tw-w-14 tw-h-14 xxs:tw-w-16 xxs:tw-h-16 tw-rounded-full tw-mr-2 tw-border-[1px] tw-shadow-z6" />
      <div class="tw-text-200 tw-text-gray-75">
        <div class="tw-font-bold">{{doctorDetails.firstName}}</div>
        @if (doctorDetails.specialization === 'Skin Specialist') {
          <div class="tw-text-nowrap" i18n="@@skinDr">Skin Specialist</div>
        } @else {
          <div class="tw-text-nowrap" i18n="@@dermatologist">Dermatologist</div>
        }
      </div>
    </div>
    <div class="tw-relative">
      <span class="shine-button tw-bg-teal-600 tw-rounded-3 tw-text-200 tw-text-white tw-font-bold tw-font-body tw-shadow-z6 tw-h-[39px] tw-px-4 tw-flex tw-justify-center tw-items-center tw-relative tw-overflow-hidden tw-text-nowrap xxs:tw-px-5 xxs:tw-text-300 xs:tw-px-8" i18n="@@startNow">Start Now</span>
      <span class="tw-w-2 tw-h-2 tw-rounded-full tw-absolute tw-right-[12px] tw-top-[-3px] tw-transform">
        <img src="/assets/gifs/blinking-red-dot.gif" alt="red-blink-circle"/>
      </span>
    </div>
  </div>
</div> 